import React, { useState, useEffect } from 'react';
import Form from '../../../../adminpanel/components/commonComponents/Form.v2';
import ModalComponent from '../../../../adminpanel/components/commonComponents/ModalComponent';
import CallAPI from '../../../../adminpanel/components/commonComponents/AxiosHelper';
import { ButtonComponent } from '../../commonComponents/UIComponent';
import { ModalDetails } from './ModalDetails';
import { connect } from 'react-redux';

const forDisplayEdit = {
    "connectionNameDisplay": {
        "label": "Connection Name", "name": "connectionNameDisplay", "type": "dropdown", "text_value": "", "options": [], "required": true, "disabled": true
    },
    "emailTypeDisplay": {
        "label": "Email Configuration Type", "name": "emailTypeDisplay", "type": "text", "text_value": "", "required": true, "disabled": true
    },
    "hostDisplay": { "label": "Host", "name": "hostDisplay", "type": "text", "required": true, "disabled": true },
    "usernameDisplay": { "label": "Username", "name": "usernameDisplay", "type": "text", "required": true, "disabled": true },
    "passwordDisplay": { "label": "Password", "name": "passwordDisplay", "type": "password", "required": true, "disabled": true },
    "ewsVersionDisplay": {
        "label": "EWS Version", "name": "ewsVersionDisplay", "type": "dropdown", "text_value": "", "options": [
            { "name": "Select EWS Version", "value": "" },
            { "name": "Exchange2007", "value": "Exchange2007" },
            { "name": "Exchange2007_SP1", "value": "Exchange2007_SP1" },
            { "name": "Exchange2010", "value": "Exchange2010" },
            { "name": "Exchange2010_SP1", "value": "Exchange2010_SP1" },
            { "name": "Exchange2010_SP2", "value": "Exchange2010_SP2" },
            { "name": "Exchange2013", "value": "Exchange2013" },
            { "name": "Exchange2013_SP1", "value": "Exchange2013_SP1" }
        ], "disabled": true
    },
    "smtpPortDisplay": { "label": "Port", "name": "smtpPortDisplay", "type": "hide", "required": true, "disabled": true },
    "smtpSecurityTypeDisplay": {
        "label": "Security Type", "name": "smtpSecurityTypeDisplay", "type": "hide", "text_value": "", "options": [
            { "name": "Select Security Type", "value": "" },
            { "name": "TLS", "value": "tls" },
            { "name": "SMTPS", "value": "smtps" },
        ], "required": true, "disabled": true
    },
}

const EmailIntegrate = ({ authData }) => {
    const [modalInformation, setModalInformation] = useState({});
    const [formArray, setFormArray] = useState({
        data: forDisplayEdit,
        isEditFlag: 1,
        errorMessage: ""
    });
    const [responseData, setresponseData] = useState({})

    useEffect(() => {
        let params = {
            siteId: authData.siteId
        }
        CallAPI('get', '/app/fetch_email_details', null, params, 0, function (response) {
            if (response.status === true) {
                setresponseData(response.information)
                Object.keys(response.information).map((element, index) => {
                    formArray.data["connectionNameDisplay"]["options"].push({ "name": element, "value": element })
                });
            } else alert(response.error_message)
        }, authData)
    }, [])

    const modalSubmission = (e) => {
        let postBody = {};
        let params = {
            siteId: authData.siteId,
        }
        let sampleModalData = { ...modalInformation }
        $("#addEmailConfigForm").serializeArray().map(function (innerData) {
            postBody[innerData.name] = innerData.value
        })
        sampleModalData.modal['isLoading'] = true
        sampleModalData.modal['formKey'] = `addEmailConfigForm_${Math.floor(Math.random() * 10)}`;
        setModalInformation(sampleModalData);
        CallAPI('post', '/app/store_email_details', postBody, params, 0, function (response) {
            if (response.status === true) {
                alert(response.information)
            } else alert(response.error_message)
            jQuery("#addEmailConfigModal").modal('toggle');
        }, authData)
        e.preventDefault();
    }

    const handleAddButton = () => {
        ModalDetails(setModalInformation);
    }

    const handleEnableEdit = () => {
        let tempFormArray = { ...formArray.data };
        tempFormArray["connectionNameDisplay"]["disabled"] = false
        let tempValue = tempFormArray["connectionNameDisplay"]["options"][0].value;
        tempFormArray["connectionNameDisplay"]["options"].text_value = tempValue;
        tempFormArray["emailTypeDisplay"]["disabled"] = false
        tempFormArray["emailTypeDisplay"]["text_value"] = responseData[tempValue].type
        tempFormArray["hostDisplay"]["disabled"] = false
        tempFormArray["hostDisplay"]["text_value"] = responseData[tempValue].host
        tempFormArray["usernameDisplay"]["disabled"] = false
        tempFormArray["usernameDisplay"]["text_value"] = responseData[tempValue].username
        tempFormArray["passwordDisplay"]["disabled"] = false
        tempFormArray["passwordDisplay"]["text_value"] = responseData[tempValue].password
        if (responseData[tempValue].type === "ews") {
            tempFormArray["ewsVersionDisplay"]["disabled"] = false
            tempFormArray["ewsVersionDisplay"]["text_value"] = responseData[tempValue].version
        } else {
            tempFormArray["smtpPortDisplay"]["disabled"] = false
            tempFormArray["smtpPortDisplay"]["text_value"] = responseData[tempValue].port
            tempFormArray["smtpSecurityTypeDisplay"]["disabled"] = false
            tempFormArray["smtpSecurityTypeDisplay"]["text_value"] = responseData[tempValue].secure
        }
        setFormArray({ data: { ...tempFormArray }, isEditFlag: 0 });
    }

    const handleDisableEdit = () => {
        
    }
    const editFormSubmission = () => {
        
    }

    const handleConnectionDropdown = (e) => {
        let tempFormArray = { ...formArray.data };
        tempFormArray[e.target.name].text_value = e.target.value
        tempFormArray["emailTypeDisplay"]["text_value"] = responseData[e.target.value].type
        tempFormArray["hostDisplay"]["text_value"] = responseData[e.target.value].host
        tempFormArray["usernameDisplay"]["text_value"] = responseData[e.target.value].username
        tempFormArray["passwordDisplay"]["text_value"] = responseData[e.target.value].password
        if (responseData[e.target.value].type === "ews") {
            tempFormArray["ewsVersionDisplay"]["disabled"] = false
            tempFormArray["ewsVersionDisplay"]["type"] = "dropdown"
            tempFormArray["ewsVersionDisplay"]["text_value"] = responseData[e.target.value].version
            tempFormArray["smtpPortDisplay"]["type"] = "hide"
            tempFormArray["smtpSecurityTypeDisplay"]["type"] = "hide"
        } else {
            tempFormArray["ewsVersionDisplay"]["type"] = "hide"
            tempFormArray["smtpPortDisplay"]["disabled"] = false
            tempFormArray["smtpPortDisplay"]["type"] = "text"
            tempFormArray["smtpPortDisplay"]["text_value"] = responseData[e.target.value].port
            tempFormArray["smtpSecurityTypeDisplay"]["disabled"] = false
            tempFormArray["smtpSecurityTypeDisplay"]["type"] = "text"
            tempFormArray["smtpSecurityTypeDisplay"]["text_value"] = responseData[e.target.value].secure
        }
        setFormArray({ ...formArray, data: { ...tempFormArray } });
    }

    let displayModal = null;
    if (modalInformation.modal) {
        let filterForm = null;
        filterForm = modalInformation.formData && Object.keys(modalInformation.formData).length > 0
            ? <Form
                label_array={modalInformation.formData} />
            : null;
        modalInformation.modal['body'] = filterForm;
        modalInformation.modal['formKey'] = `addEmailConfigForm${Math.floor(Math.random() * 10)}`;
        modalInformation.modal['isLoading'] = false
        displayModal = modalInformation.modal && Object.keys(modalInformation.modal).length > 0 ? <ModalComponent modalConfig={modalInformation.modal} formSubmit={modalSubmission} /> : null
    }

    let addConnectionButton = { "className": `btn btn-primary btn-sm text-white`, "name": "Add New Connection", "type": "add", "icon": "plus", "event": handleAddButton };
    let editConnectionButton = { "className": `btn btn-primary btn-sm text-white float-right`, "name": formArray.isEditFlag == 0 ? "Disable Edit" : "Enable Edit", "type": "add", "icon": "edit-2", "event": formArray.isEditFlag == 0 ? handleDisableEdit : handleEnableEdit };
    let updateChangeButton = {"className": `btn btn-primary btn-sm text-white ${formArray.isEditFlag === 1 ? "disabled" : null}`, "name": "Update Changes", "type": "add", "icon": "plus", "event": editFormSubmission};
    let error_alert = (
        <div className="alert alert-outline alert-danger d-flex justify-content-center align-items-center" role="alert">
            <i data-feather="alert-circle" className="mg-r-10"></i> {formArray.errorMessage}
        </div>
    );

    return (
        <div className="card">
            <div className="card-header">
                <ButtonComponent buttonData={addConnectionButton} />
                <ButtonComponent buttonData={editConnectionButton} />
            </div>
            <div className="card-body">
                <form className={"wd-300"} id='updateChangesForm'>
                    <Form label_array={formArray.data} handle_form_drop_down={handleConnectionDropdown} />
                    <ButtonComponent buttonData={updateChangeButton} />
                    {formArray.errorMessage ? error_alert : null}
                </form>
            </div>
            {displayModal}
        </div>
    )
}

function mapStateToProps(state) {
    return { authData: state.dataSet.authData };
}

export default connect(mapStateToProps, null)(EmailIntegrate);
